<template>
  <section class="redemption-guide" aria-label="兑换码使用引导">
    <div class="redemption-guide__heading">
      <h4><i class="ri-coupon-3-line" aria-hidden="true" />有兑换码？</h4>
      <RouterLink
        v-if="!disabled"
        :to="{ name: 'account-coupons' }"
        class="checkout-redeem"
        @click="emit('redeem')"
        >使用兑换码<i class="ri-arrow-right-line" aria-hidden="true"
      /></RouterLink>
      <span v-else class="checkout-redeem" aria-disabled="true">使用兑换码</span>
    </div>
    <p>
      前往卡券中心输入兑换码领取卡券。<strong>优惠券用于结算抵扣</strong>，<strong>权益券可直接兑换到账</strong>。
    </p>
  </section>
</template>

<script setup lang="ts">
import { RouterLink } from 'vue-router';
defineProps<{ disabled?: boolean }>();
const emit = defineEmits<{ redeem: [] }>();
</script>

<style scoped>
.redemption-guide {
  padding: 12px 16px;
  border: 1px solid color-mix(in srgb, var(--aw-primary) 24%, var(--aw-border));
  border-radius: var(--aw-radius-md);
  background: var(--aw-primary-soft);
  color: var(--aw-text);
}
.redemption-guide__heading {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
h4 {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 14px;
  font-weight: 650;
}
h4 i {
  color: var(--aw-primary);
  font-size: 20px;
}
p {
  margin: 8px 0 0;
  font-size: 12px;
  line-height: 1.8;
  overflow-wrap: anywhere;
}
strong {
  font-weight: 600;
}
.checkout-redeem {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 44px;
  padding: 0 12px;
  border: 1px solid var(--aw-primary);
  border-radius: var(--aw-radius-sm);
  background: var(--aw-surface);
  color: var(--aw-primary);
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
}
.checkout-redeem:hover {
  background: var(--aw-primary);
  color: var(--aw-on-primary);
}
.checkout-redeem:focus-visible {
  outline: 2px solid var(--aw-primary);
  outline-offset: 3px;
}
.checkout-redeem[aria-disabled] {
  border-color: var(--aw-border);
  color: var(--aw-text-secondary);
}
</style>
